import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-secondary-100/80 text-secondary-700 text-xs font-semibold rounded-full mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            常见问答
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于豆花视频，你可能想了解的一切
          </p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 transition-transform duration-200">
                  <i
                    className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}